var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCompass = function SvgCompass(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 114a50 50 0 1 1 0-100 50 50 0 0 1 0 100m0-94a44 44 0 1 0 0 88 44 44 0 0 0 0-88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m40.73 89.25 13.91-34.73 34.6-13.79-13.9 34.73-34.6 13.79zM59.3 59.17l-7.68 19.16 19.16-7.68 7.68-19.16z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.72 86.28 12.29-31.69L74.4 74.63zm7.19-7.1 19.59-7.91"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCompass);
export default ForwardRef;